import { Injectable } from "@angular/core";
import { createDefaultProducts } from "@zp-config/product.config";
import { Product } from "@zp-models/product";

@Injectable({
  providedIn: "root",
})
export class ProductService {
  public products: Product[] = createDefaultProducts();

  constructor() {}

  getProducts(): Product[] {
    return this.products;
  }

  getProductByIndex(index: number): Product | undefined {
    if (this.products.length === 0) return undefined;

    if (index < 0 || index >= this.products.length) {
      return this.products[0];
    }

    return this.products[index];
  }

  getProductById(id: number): Product {
    const product = this.products.find((p) => p.id === id);

    if (!product) {
      throw new Error(`Product with ID ${id} not found.`);
    }

    return product;
  }

  setProducts(products: Product[]): void {
    this.products = products;
  }
}
